const ContributeBtn = () => {
	return (
		<a href="/create" className="contribute_btn">
			Contribute
		</a>
	);
};

export default ContributeBtn;
